/* A visitor preference, shared across storefront pages and browser tabs. */
(() => {
  const root = document.documentElement;
  const key = 'dut-color-mode';
  const updateControls = () => {
    const dark = root.dataset.dutTheme === 'dark';
    document.querySelectorAll('[data-dut-theme-switch]').forEach((control) => {
      control.hidden = false;
    });
    document.querySelectorAll('[data-dut-theme-set]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.dutThemeSet === (dark ? 'dark' : 'light')));
    });
    document.querySelectorAll('[data-dut-theme-toggle]').forEach((button) => {
      button.hidden = false;
      button.setAttribute('aria-pressed', String(dark));
      // Keep the accessible name stable: pressed means that dark mode is on.
      button.setAttribute('aria-label', 'Dark mode');
      const label = button.querySelector('[data-dut-theme-label]');
      if (label) label.textContent = 'Dark mode';
    });
  };
  const apply = (mode, save = false) => {
    root.dataset.dutTheme = mode === 'dark' ? 'dark' : 'light';
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = root.dataset.dutTheme === 'dark' ? '#0c0a0e' : (matchMedia('(max-width: 989px)').matches ? '#faf8f5' : '#663149');
    if (save) {
      try { localStorage.setItem(key, root.dataset.dutTheme); } catch (_) {}
    }
    updateControls();
  };
  document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-dut-theme-set]');
    if (choice) {
      apply(choice.dataset.dutThemeSet, true);
      return;
    }
    if (!event.target.closest('[data-dut-theme-toggle]')) return;
    apply(root.dataset.dutTheme === 'dark' ? 'light' : 'dark', true);
  });
  window.addEventListener('storage', (event) => {
    if (event.key === key || event.key === null) apply(event.newValue);
  });
  document.addEventListener('shopify:section:load', updateControls);
  matchMedia('(max-width: 989px)').addEventListener('change', () => apply(root.dataset.dutTheme));
  apply(root.dataset.dutTheme);
})();
